import { apiClient } from '../apiClient';

/**
 * Common Function for Frontend Operation Logging (操作履歴: admin_operation_logs)
 */
export const logAdminOperation = async ({
  operation_type,
  target_type,
  target_id = '',
  target_name = '',
  reason = '',
  before_value = {},
  after_value = {}
}) => {
  try {
    await apiClient.post('/v1/admin/operation-logs', {
      operation_type,
      target_type,
      target_id,
      target_name,
      reason,
      before_value,
      after_value
    });
  } catch (error) {
    console.error('Failed to record admin operation log:', error);
  }
};
